import React from "react";
import { useTranslation } from 'react-i18next';
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import Fade from "@mui/material/Fade";

const RECOMMENDED_PROMPTS = [
  "Show me 5 parcels from the database",
  "What is the total revenue from charges?",
  "How many invoices do we have?",
  "Show me top 5 customers by invoice count"
];

const StaticRecommendedPrompts = ({ onPromptClick, show }) => {
  const { t } = useTranslation();
  
  if (!show) return null;

  return (
    <Fade in={show} timeout={800}>
      <Box sx={{ mt: 2, mb: 1 }}>
        <Typography
          variant="subtitle2"
          color="primary"
          sx={{ 
            fontSize: "0.8rem", 
            fontWeight: 500, 
            mb: 1,
            opacity: 0.8
          }}
        >
          {t('chat.tryAsking', 'Try asking:')}
        </Typography>
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          gap: 1,
          flexWrap: 'wrap'
        }}>
          {RECOMMENDED_PROMPTS.map((prompt, index) => (
            <Chip
              key={`prompt-${index}`}
              label={prompt}
              onClick={() => onPromptClick(prompt)}
              size="small"
              sx={{
                fontSize: '0.75rem',
                fontWeight: 400,
                lineHeight: 1.2,
                cursor: 'pointer',
                backgroundColor: 'rgba(0, 0, 255, 0.08)',
                color: 'primary.main',
                border: '1px solid',
                borderColor: 'rgba(0, 0, 255, 0.2)',
                borderRadius: '16px',
                height: 'auto',
                padding: '4px 8px',
                minHeight: '28px',
                justifyContent: 'flex-start',
                '&:hover': {
                  backgroundColor: 'primary.main',
                  color: 'white',
                  transform: 'translateY(-1px)',
                  boxShadow: '0 4px 8px rgba(0, 0, 255, 0.15)',
                },
                '& .MuiChip-label': {
                  padding: '0',
                  display: 'block',
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  textAlign: 'left'
                },
                transition: 'all 0.2s ease-in-out',
              }}
              clickable
            />
          ))}
        </Box>
      </Box>
    </Fade>
  );
};

export default StaticRecommendedPrompts;
